<template>
  <ul class="sidebar-controls sidebar-controls--back">
    <router-link
      tag="li"
      :to="`/thread-id-${$route.params.id}`"
      class="sidebar-controls__item"
    >
      К лентам
    </router-link>
  </ul>
</template>

<script>
export default {
  name: 'BackButton',
};
</script>

<style>
</style>
